// same as src/Manager/UserFileManager.php, PREVIEWABLE_MIMETYPES
export enum PreviewableMimeType {
  WEBP = 'image/webp',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
  HEIC = 'image/heic',
}

export const PREVIEWABLE_MIMETYPES = Object.values(PreviewableMimeType) as string[];
